import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {Question} from '../../models/underwriter.model';
import {newGuid, parseOptions} from '../question-helper';

@Component({
    selector: 'app-question-radio-column',
    templateUrl: './question-radio-column.component.html',
    styleUrls: ['./question-radio-column.component.scss'],
    standalone: false
})
export class QuestionRadioColumnComponent implements OnInit, OnChanges {

  @Input() question: Question;
  @Input() items: any[] = [];
  @Input() selectedOption: any;
  @Input() readOnly = false;
  @Input() showLabel = true;
  @Input() useQuestionCopy = false;
  @Output() questionAnswer = new EventEmitter<any>();

  uniqueControlName = `radio-button-${newGuid()}`;
  idCount = 1;

  constructor() {
  }

  ngOnInit(): void {
    if (this.question?.options?.length) {
      this.items = parseOptions(this.question.options);
    } else if (!this.items?.length) {
      this.items = [{answer: 'Yes'}, {answer: 'No'}];
    }
    if (this.question?.answer) {
      for (const q of this.items) {
        if (q === this.question?.answer) {
          this.checkRadio(q.answer);
        }
      }
    } else {
      this.checkRadio(this.items[0].answer);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.question?.currentValue !== changes?.question?.previousValue) {
      this.question = changes?.question?.currentValue;
      this.items = parseOptions(this.question?.options);
    } else if (changes?.items?.currentValue) {
      this.items = changes?.items?.currentValue;
    }
    if (changes?.showLabel?.currentValue !== changes?.showLabel?.previousValue) {
      this.showLabel = changes?.showLabel?.currentValue;
    }
    if (changes?.readOnly?.currentValue !== changes?.readOnly?.previousValue) {
      this.readOnly = changes?.readOnly?.currentValue;
    }
    if (changes?.selectedOption?.currentValue !== changes?.selectedOption?.previousValue) {
      this.selectedOption = changes?.selectedOption?.currentValue;
    }
  }

  checkRadio(answer: any): void {
    if (this.question) {
      this.question.answer = answer;
      this.questionAnswer.emit(this.question);
    } else {
      this.questionAnswer.emit(answer);
    }
  }

}
